<nz-layout>
  @if (submenu?.length! <= 1) {
    <nz-header> </nz-header>
  }
  @if (submenu?.length! > 1) {
    <nz-header class="section-header">
      {{ "Imaging" | translate }}
    </nz-header>
  }
  <nz-content>
    @for (cm of submenu; track cm) {
      @if (cm.path == componentPaths.imagingFiles) {
        <app-imaging-files [id]="cm.path" />
      }
      @if (cm.path == componentPaths.multipleSclerosisSegmentation) {
        <app-multiple-sclerosis-segmentation [id]="cm.path" />
      }
      @if (cm.path == componentPaths.preciousMedSamSegmentation) {
        <app-precious-med-sam-segmentation [id]="cm.path" />
      }
      @if (cm.path == componentPaths.protectMedSamSegmentation) {
        <app-protect-med-sam-segmentation [id]="cm.path" />
      }
    }
  </nz-content>
</nz-layout>
